import React, { useState, useEffect } from 'react';
import { ChevronDown, Star, X, Plus, Minus, ChevronLeft, ChevronRight } from 'lucide-react';
import toast, { Toaster } from 'react-hot-toast';
import logo from '../assets/logo.png';
import taille from '../assets/taille.webp'


import img1 from '../assets/images/products/new1.png'
import img2 from '../assets/images/products/new2.png'
import img3 from '../assets/images/products/new3.png'
import img4 from '../assets/images/products/new4.png'
import img5 from '../assets/images/products/new5.png'


export default function Two() {
  const [selectedSize, setSelectedSize] = useState('3-4');
  const [selectedColor, setSelectedColor] = useState('lightGray');
  const [quantity, setQuantity] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    address: '',
    city: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSizeGuide, setShowSizeGuide] = useState(false);
  const [activeTab, setActiveTab] = useState('body');
  const [unit, setUnit] = useState('CM');



  const colors = [
    { name: 'رمادي فاتح', value: 'lightGray', hex: '#abcad5' },
    { name: 'أخضر زيتوني', value: 'oliveGreen', hex: '#9eae8b' },
  ];

  // Images associées à chaque couleur (entre 4 et 6 images par couleur)
  const lightGrayImages = [img1, img2];
  const oliveGreenImages = [img3, img4, img5];

  const colorImages = {
    lightGray: lightGrayImages,
    oliveGreen: oliveGreenImages
  };

  // Fonction pour obtenir les images de la couleur sélectionnée
  const getCurrentImages = () => {
    return colorImages[selectedColor] || colorImages.lightGray;
  };

  // Réinitialiser l'index quand la couleur change
  useEffect(() => {
    setCurrentImageIndex(0);
  }, [selectedColor]);

  // Fonctions pour naviguer dans le slider mobile
  const nextImage = () => {
    const images = getCurrentImages();
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    const images = getCurrentImages();
    setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const sizes = ['3-4', '5-6', '7-8', '9-10', '11-12'];

  // Fonction pour obtenir les prix selon la taille
  const getPriceBySize = (size) => {
    return 250;
  };

  const handleQuantityChange = (type) => {
    if (type === 'increase') {
      setQuantity(prev => prev + 1);
    } else if (type === 'decrease' && quantity > 1) {
      setQuantity(prev => prev - 1);
    }
  };

  const handleAddToCart = () => {
    setShowModal(true);
    setIsSubmitting(false);
    const price = getPriceBySize(selectedSize);
    if (window.fbq) {
      window.fbq('track', 'AddToCart', { value: price, currency: 'USD' });
    }
    setFormData({
      fullName: '',
      phone: '',
      address: '',
      city: ''
    });
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmitOrder = (e) => {
    e.preventDefault();
    console.log("Submit button clicked");

    // Prevent duplicate submissions
    if (isSubmitting) {
      console.log("Already submitting");
      return;
    }

    // Manual Validation
    if (!formData.fullName.trim() || !formData.phone.trim() || !formData.address.trim() || !formData.city.trim()) {
      toast.error('المرجو ملء جميع الخانات المطلوبة', { duration: 3000 });
      console.log("Validation failed");
      return;
    }

    setIsSubmitting(true);
    const loadingToast = toast.loading('جاري إرسال طلبك...');

    // Pixel Tracking
    if (window.fbq) {
      const eventId = `purchase_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      window.fbq('track', 'Purchase', {
        value: totalPrice,
        currency: 'USD',
        eventID: eventId
      });
    }

    const url = "https://script.google.com/macros/s/AKfycbzFAd_7MYWBRVyCUjNXsD_XpYsFIdGdW5V2d7O2qk4DTzzuLelnuxS-goTDbzjPftdJNA/exec";
    const product = "الأناقة والراحة التي يستحقها أطفالك في طقم واحد✨";
    const color = colors.find(c => c.value === selectedColor)?.name || selectedColor;


    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
      },
      body: `Name=${encodeURIComponent(formData.fullName)}&Phone=${encodeURIComponent(formData.phone)}&Address=${encodeURIComponent(formData.address)}&City=${encodeURIComponent(formData.city)}&Product=${encodeURIComponent(product)}&Color=${encodeURIComponent(color)}&Size=${encodeURIComponent(selectedSize)}&Quantity=${encodeURIComponent(quantity)}&Price=${encodeURIComponent(totalPrice)}`
    })
      .then(res => {
        if (!res.ok) {
          throw new Error('Network response was not ok');
        }
        return res.json();
      })
      .then(data => {
        toast.dismiss(loadingToast);
        if (data.status === 'success') {
          toast.success('تم إرسال طلبك بنجاح! سنتواصل معك قريباً.', { duration: 4000 });
          setShowModal(false);
          setFormData({ fullName: '', phone: '', address: '', city: '' });
        } else {
          toast.error('حدث خطأ: ' + data.message, { duration: 4000 });
          console.error("Script error:", data.message);
        }
        setIsSubmitting(false);
      })
      .catch(error => {
        toast.dismiss(loadingToast);
        toast.error('حدث خطأ أثناء إرسال الطلب. يرجى المحاولة مرة أخرى.', { duration: 4000 });
        setShowModal(false);
        setIsSubmitting(false);
        console.error("Order submission error:", error);
      });
  };

  const basePrice = getPriceBySize(selectedSize);
  const totalPrice = basePrice * quantity;

  // Function to determine if color is light or dark
  const isLightColor = (hex) => {
    const rgb = parseInt(hex.slice(1), 16);
    const r = (rgb >> 16) & 0xff;
    const g = (rgb >> 8) & 0xff;
    const b = (rgb >> 0) & 0xff;
    const luma = 0.299 * r + 0.587 * g + 0.114 * b;
    return luma > 155;
  };

  const selectedColorHex = colors.find(c => c.value === selectedColor)?.hex;
  const textColor = isLightColor(selectedColorHex) ? 'text-black' : 'text-white';

  return (
    <>
      <div className="bg-white">
        {/* Top Banner */}
        <div className="bg-black text-white text-xs py-2 overflow-hidden">
          <div className="flex animate-marquee whitespace-nowrap">
            <span className="mx-8">🚚 التوصيل بالمجان في جميع أنحاء المغرب</span>
            <span className="mx-8">🚚 التوصيل بالمجان في جميع أنحاء المغرب</span>
            <span className="mx-8">🚚 التوصيل بالمجان في جميع أنحاء المغرب</span>
            <span className="mx-8">🚚 التوصيل بالمجان في جميع أنحاء المغرب</span>
            <span className="mx-8">🚚 التوصيل بالمجان في جميع أنحاء المغرب</span>
            <span className="mx-8">🚚 التوصيل بالمجان في جميع أنحاء المغرب</span>
            <span className="mx-8">🚚 التوصيل بالمجان في جميع أنحاء المغرب</span>
            <span className="mx-8">🚚 التوصيل بالمجان في جميع أنحاء المغرب</span>
          </div>
        </div>

        <style jsx>{`
        @keyframes marquee {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(33.333%);
          }
        }
        
        .animate-marquee {
          display: flex;
          animation: marquee 20s linear infinite;
        }
        
        .animate-marquee:hover {
          animation-play-state: paused;
        }
      `}</style>

        {/* Header */}
        <header className="border-b sticky top-0 bg-white/60 backdrop-blur-lg z-50">
          <div className="relative container mx-auto px-4 py-4 hidden md:flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <a href="https://www.facebook.com/share/17ehhEKWB9/?mibextid=wwXIfr" className="cursor-pointer">
                <svg xmlns="http://www.w3.org/2000/svg" className='w-6 h-6 text-black' viewBox="0 0 48 48"><path fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="3.8" d="M36 12.6h-6.013c-1.086 0-1.967.88-1.967 1.967v6.9H36l-1.169 7.597h-6.81V43h-8.776V29.064H12v-7.597h7.151l.094-7.21l-.013-1.31A7.87 7.87 0 0 1 27.099 5H36z" /></svg>
              </a>
              <a href="https://www.instagram.com/oumac_hic?igsh=NWxpc21lZDBtN2Q3&utm_source=qr" className="cursor-pointer">
                <svg xmlns="http://www.w3.org/2000/svg" className='w-6 h-6 text-black' viewBox="0 0 24 24"><path fill="currentColor" d="M12 1q-3.195 0-4.59.074a9.3 9.3 0 0 0-2.43.417c-.803.286-1.53.748-2.14 1.35S1.78 4.17 1.49 4.98a9.3 9.3 0 0 0-.417 2.43C1.023 8.344.999 9.87.999 12q0 3.195.074 4.59c.03.825.17 1.64.417 2.43a5.8 5.8 0 0 0 1.35 2.14c.596.6 1.33 1.05 2.14 1.3c.781.28 1.6.437 2.43.466c.933.05 2.46.074 4.59.074q3.195 0 4.59-.074a9.3 9.3 0 0 0 2.43-.417a5.8 5.8 0 0 0 2.14-1.35a5.8 5.8 0 0 0 1.35-2.14c.247-.788.387-1.61.417-2.43c.05-.933.074-2.46.074-4.59s-.016-3.65-.049-4.57a10 10 0 0 0-.442-2.46a5.8 5.8 0 0 0-1.35-2.14a5.8 5.8 0 0 0-2.14-1.35a9.3 9.3 0 0 0-2.43-.417c-.933-.05-2.46-.074-4.59-.074zm-.786 20c-1.31 0-2.32-.016-3.04-.049a10.3 10.3 0 0 1-2.65-.393a3.7 3.7 0 0 1-2.114-2.115a10.3 10.3 0 0 1-.393-2.65c-.033-.72-.05-1.74-.05-3.04v-1.57c0-1.31.017-2.32.05-3.04a9.8 9.8 0 0 1 .393-2.65a3.54 3.54 0 0 1 2.112-2.112a10.3 10.3 0 0 1 2.65-.393c.72-.033 1.74-.05 3.04-.05h1.57c1.31 0 2.32.017 3.04.05a9.8 9.8 0 0 1 2.65.393a3.54 3.54 0 0 1 2.113 2.112c.251.862.383 1.75.393 2.65q.048 1.031.049 3.04v1.57c0 1.31-.017 2.32-.049 3.04c-.016.897-.148 1.79-.393 2.65a3.8 3.8 0 0 1-.835 1.28a3.7 3.7 0 0 1-1.28.835a10 10 0 0 1-2.65.393q-1.03.05-3.04.049h-1.57zm6.68-16.3a1.37 1.37 0 0 0-.967 2.342a1.32 1.32 0 0 0 .968.408a1.24 1.24 0 0 0 .943-.408a1.6 1.6 0 0 0 .432-.967A1.394 1.394 0 0 0 17.894 4.7m-5.89 1.77a5.34 5.34 0 0 0-2.75.741a5.53 5.53 0 0 0-2.01 2.01a5.47 5.47 0 0 0 0 5.5a5.5 5.5 0 0 0 2.01 2.01a5.47 5.47 0 0 0 5.5 0a5.5 5.5 0 0 0 2.01-2.01a5.47 5.47 0 0 0 0-5.5a5.53 5.53 0 0 0-2.01-2.01a5.34 5.34 0 0 0-2.75-.741m0 9.04a3.53 3.53 0 0 1-2.5-1.04a3.54 3.54 0 0 1-1.04-2.5a3.53 3.53 0 0 1 1.04-2.5a3.54 3.54 0 0 1 2.5-1.04a3.53 3.53 0 0 1 2.5 1.04a3.54 3.54 0 0 1 1.04 2.5a3.53 3.53 0 0 1-1.04 2.5a3.54 3.54 0 0 1-2.5 1.04" /></svg>
              </a>
              <a href="https://www.tiktok.com/@oumac_hic?lang=fr&is_from_webapp=1&sender_device=mobile&sender_web_id=7539752922411976248" className="cursor-pointer">
                <svg xmlns="http://www.w3.org/2000/svg" className='w-6 h-6 text-black' viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22 6v5q-4 0-6-2v7a7 7 0 1 1-5-6.7m0 6.7a2 2 0 1 0-2 2a2 2 0 0 0 2-2V1h5q2 5 6 5" /></svg>
              </a>
            </div>
            <img src={logo} alt="logo" className="w-14 h-auto absolute right-1/2 translate-x-1/2" />


            <div className="flex items-center space-x-4">
              <a href="https://wa.me/212684028678" className="cursor-pointer flex items-center gap-1">
                <svg xmlns="http://www.w3.org/2000/svg" className='w-6 h-6 text-black' viewBox="0 0 1536 1600"><path fill="currentColor" d="M985 878q13 0 97.5 44t89.5 53q2 5 2 15q0 33-17 76q-16 39-71 65.5T984 1158q-57 0-190-62q-98-45-170-118T476 793q-72-107-71-194v-8q3-91 74-158q24-22 52-22q6 0 18 1.5t19 1.5q19 0 26.5 6.5T610 448q8 20 33 88t25 75q0 21-34.5 57.5T599 715q0 7 5 15q34 73 102 137q56 53 151 101q12 7 22 7q15 0 54-48.5t52-48.5m-203 530q127 0 243.5-50t200.5-134t134-200.5t50-243.5t-50-243.5T1226 336t-200.5-134T782 152t-243.5 50T338 336T204 536.5T154 780q0 203 120 368l-79 233l242-77q158 104 345 104m0-1382q153 0 292.5 60T1315 247t161 240.5t60 292.5t-60 292.5t-161 240.5t-240.5 161t-292.5 60q-195 0-365-94L0 1574l136-405Q28 991 28 780q0-153 60-292.5T249 247T489.5 86T782 26" /></svg>
                <span className='font-medium'>+212 684028678</span>
              </a>
            </div>
          </div>
          <div className="container mx-auto px-4 py-4 flex md:hidden items-center justify-between">
            <img src={logo} alt="logo" className="w-14 h-auto" />


            <div className="flex items-center space-x-4">
              <a href="https://wa.me/212684028678" className="cursor-pointer">
                <svg xmlns="http://www.w3.org/2000/svg" className='w-6 h-6 text-black' viewBox="0 0 1536 1600"><path fill="currentColor" d="M985 878q13 0 97.5 44t89.5 53q2 5 2 15q0 33-17 76q-16 39-71 65.5T984 1158q-57 0-190-62q-98-45-170-118T476 793q-72-107-71-194v-8q3-91 74-158q24-22 52-22q6 0 18 1.5t19 1.5q19 0 26.5 6.5T610 448q8 20 33 88t25 75q0 21-34.5 57.5T599 715q0 7 5 15q34 73 102 137q56 53 151 101q12 7 22 7q15 0 54-48.5t52-48.5m-203 530q127 0 243.5-50t200.5-134t134-200.5t50-243.5t-50-243.5T1226 336t-200.5-134T782 152t-243.5 50T338 336T204 536.5T154 780q0 203 120 368l-79 233l242-77q158 104 345 104m0-1382q153 0 292.5 60T1315 247t161 240.5t60 292.5t-60 292.5t-161 240.5t-240.5 161t-292.5 60q-195 0-365-94L0 1574l136-405Q28 991 28 780q0-153 60-292.5T249 247T489.5 86T782 26" /></svg>
              </a>
              <a href="https://www.facebook.com/share/17ehhEKWB9/?mibextid=wwXIfr" className="cursor-pointer">
                <svg xmlns="http://www.w3.org/2000/svg" className='w-6 h-6 text-black' viewBox="0 0 48 48"><path fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="3.8" d="M36 12.6h-6.013c-1.086 0-1.967.88-1.967 1.967v6.9H36l-1.169 7.597h-6.81V43h-8.776V29.064H12v-7.597h7.151l.094-7.21l-.013-1.31A7.87 7.87 0 0 1 27.099 5H36z" /></svg>
              </a>
              <a href="https://www.instagram.com/oumac_hic?igsh=NWxpc21lZDBtN2Q3&utm_source=qr" className="cursor-pointer">
                <svg xmlns="http://www.w3.org/2000/svg" className='w-6 h-6 text-black' viewBox="0 0 24 24"><path fill="currentColor" d="M12 1q-3.195 0-4.59.074a9.3 9.3 0 0 0-2.43.417c-.803.286-1.53.748-2.14 1.35S1.78 4.17 1.49 4.98a9.3 9.3 0 0 0-.417 2.43C1.023 8.344.999 9.87.999 12q0 3.195.074 4.59c.03.825.17 1.64.417 2.43a5.8 5.8 0 0 0 1.35 2.14c.596.6 1.33 1.05 2.14 1.3c.781.28 1.6.437 2.43.466c.933.05 2.46.074 4.59.074q3.195 0 4.59-.074a9.3 9.3 0 0 0 2.43-.417a5.8 5.8 0 0 0 2.14-1.35a5.8 5.8 0 0 0 1.35-2.14c.247-.788.387-1.61.417-2.43c.05-.933.074-2.46.074-4.59s-.016-3.65-.049-4.57a10 10 0 0 0-.442-2.46a5.8 5.8 0 0 0-1.35-2.14a5.8 5.8 0 0 0-2.14-1.35a9.3 9.3 0 0 0-2.43-.417c-.933-.05-2.46-.074-4.59-.074zm-.786 20c-1.31 0-2.32-.016-3.04-.049a10.3 10.3 0 0 1-2.65-.393a3.7 3.7 0 0 1-2.114-2.115a10.3 10.3 0 0 1-.393-2.65c-.033-.72-.05-1.74-.05-3.04v-1.57c0-1.31.017-2.32.05-3.04a9.8 9.8 0 0 1 .393-2.65a3.54 3.54 0 0 1 2.112-2.112a10.3 10.3 0 0 1 2.65-.393c.72-.033 1.74-.05 3.04-.05h1.57c1.31 0 2.32.017 3.04.05a9.8 9.8 0 0 1 2.65.393a3.54 3.54 0 0 1 2.113 2.112c.251.862.383 1.75.393 2.65q.048 1.031.049 3.04v1.57c0 1.31-.017 2.32-.049 3.04c-.016.897-.148 1.79-.393 2.65a3.8 3.8 0 0 1-.835 1.28a3.7 3.7 0 0 1-1.28.835a10 10 0 0 1-2.65.393q-1.03.05-3.04.049h-1.57zm6.68-16.3a1.37 1.37 0 0 0-.967 2.342a1.32 1.32 0 0 0 .968.408a1.24 1.24 0 0 0 .943-.408a1.6 1.6 0 0 0 .432-.967A1.394 1.394 0 0 0 17.894 4.7m-5.89 1.77a5.34 5.34 0 0 0-2.75.741a5.53 5.53 0 0 0-2.01 2.01a5.47 5.47 0 0 0 0 5.5a5.5 5.5 0 0 0 2.01 2.01a5.47 5.47 0 0 0 5.5 0a5.5 5.5 0 0 0 2.01-2.01a5.47 5.47 0 0 0 0-5.5a5.53 5.53 0 0 0-2.01-2.01a5.34 5.34 0 0 0-2.75-.741m0 9.04a3.53 3.53 0 0 1-2.5-1.04a3.54 3.54 0 0 1-1.04-2.5a3.53 3.53 0 0 1 1.04-2.5a3.54 3.54 0 0 1 2.5-1.04a3.53 3.53 0 0 1 2.5 1.04a3.54 3.54 0 0 1 1.04 2.5a3.53 3.53 0 0 1-1.04 2.5a3.54 3.54 0 0 1-2.5 1.04" /></svg>
              </a>
              <a href="https://www.tiktok.com/@oumac_hic?lang=fr&is_from_webapp=1&sender_device=mobile&sender_web_id=7539752922411976248" className="cursor-pointer">
                <svg xmlns="http://www.w3.org/2000/svg" className='w-6 h-6 text-black' viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22 6v5q-4 0-6-2v7a7 7 0 1 1-5-6.7m0 6.7a2 2 0 1 0-2 2a2 2 0 0 0 2-2V1h5q2 5 6 5" /></svg>
              </a>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <div className="container mx-auto px-4 py-8">
          <div className="grid md:grid-cols-[2fr_3fr] lg:grid-cols-[3fr_2fr] gap-8 mb-5">
            {/* Images Grid */}
            <div className='flex flex-col lg:sticky lg:top-24 lg:self-start'>
              {/* Mobile: Slider horizontal */}
              <div className="md:hidden relative">
                <div className="overflow-hidden relative">
                  <div
                    className="flex transition-transform duration-300 ease-in-out"
                    style={{ transform: `translateX(-${currentImageIndex * 100}%)` }}
                  >
                    {getCurrentImages().map((img, index) => (
                      <div key={`mobile-${index}`} className="w-full flex-shrink-0">
                        <img
                          src={img}
                          alt={`Product ${index + 1} - ${colors.find(c => c.value === selectedColor)?.name}`}
                          className="w-full h-auto object-contain"
                        />
                      </div>
                    ))}
                  </div>
                </div>
                {/* Navigation buttons */}
                {getCurrentImages().length > 1 && (
                  <>
                    <button
                      onClick={prevImage}
                      className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-2 shadow-lg"
                    >
                      <ChevronRight className="w-5 h-5" />
                    </button>
                    <button
                      onClick={nextImage}
                      className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-2 shadow-lg"
                    >
                      <ChevronLeft className="w-5 h-5" />
                    </button>
                    {/* Dots indicator */}
                    <div className="flex justify-center gap-2 mt-4">
                      {getCurrentImages().map((_, index) => (
                        <button
                          key={index}
                          onClick={() => setCurrentImageIndex(index)}
                          className={`w-2 h-2 rounded-full transition-all ${index === currentImageIndex ? 'bg-black w-6' : 'bg-gray-300'
                            }`}
                        />
                      ))}
                    </div>
                  </>
                )}
              </div>

              {/* Tablette: Une image par ligne */}
              <div className="hidden md:flex lg:hidden flex-col gap-4">
                {getCurrentImages().map((img, index) => (
                  <div key={`tablet-${index}`} className="w-full">
                    <img
                      src={img}
                      alt={`Product ${index + 1} - ${colors.find(c => c.value === selectedColor)?.name}`}
                      className="w-full h-[400px] object-cover"
                    />
                  </div>
                ))}
              </div>

              {/* Desktop: Grid avec 2 images en haut et 2 en bas */}
              <div className="hidden lg:flex flex-col">
                {/* Top row - two large images */}
                <div className="grid grid-cols-2 gap-2 flex-1 mb-2">
                  {getCurrentImages().slice(0, 2).map((img, index) => (
                    <div key={`large-${index}`} className='h-[600px]'>
                      <img
                        src={img}
                        alt={`Product ${index + 1} - ${colors.find(c => c.value === selectedColor)?.name}`}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  ))}
                </div>
                {/* Bottom row - smaller images */}
                <div className="grid grid-cols-2 gap-2">
                  {getCurrentImages().slice(2).map((img, index) => (
                    <div key={`small-${index}`} className='h-[600px]'>
                      <img
                        src={img}
                        alt={`Product ${index + 3} - ${colors.find(c => c.value === selectedColor)?.name}`}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Product Info */}
            <div>
              <div className="text-sm text-gray-500 mb-2">
                الرئيسية / أطفال / الأناقة والراحة التي يستحقها أطفالك في طقم واحد✨
              </div>

              <div className="flex items-center mb-2">
                {[1, 2, 3, 4, 5].map(i => (
                  <Star key={i} className="w-4 h-4 fill-black" />
                ))}
                <span className="mr-2 text-sm text-gray-600">(62 تقييم)</span>
              </div>

              <h1 className="text-3xl font-bold mb-4">الأناقة والراحة التي يستحقها أطفالك في طقم واحد✨</h1>

              <div className="flex items-center flex-row gap-3 mb-6">
                <span className="bg-red-600 text-white px-2 py-1 text-xs rounded">عرض</span>
                <span className="text-3xl font-bold">{basePrice} درهم</span>
                <span className="text-gray-400 line-through text-lg">350 درهم</span>
              </div>

              {/* Color Selection */}
              <div className="mb-6">
                <div className="text-sm mb-3">اللون: {colors.find(c => c.value === selectedColor)?.name}</div>
                <div className="flex flex-wrap gap-2">
                  {colors.map(color => (
                    <button
                      key={color.value}
                      onClick={() => setSelectedColor(color.value)}
                      className={`w-8 h-8 rounded-full border-2 ${selectedColor === color.value ? 'border-black' : 'border-transparent'
                        }`}
                      style={{ backgroundColor: color.hex }}
                    />
                  ))}
                </div>
              </div>

              {/* Size Selection */}
              <div className="mb-6">
                <div className="flex justify-between mb-3">
                  <span className="text-sm">المقاس: {selectedSize} - اختر المقاس حسب العمر</span>
                  <button
                    onClick={() => setShowSizeGuide(true)}
                    className="text-sm underline hover:no-underline"
                  >
                    دليل المقاسات
                  </button>
                </div>
                <div className="flex gap-2">
                  {sizes.map(size => (
                    <button
                      key={size}
                      onClick={() => setSelectedSize(size)}
                      className={`px-3 py-2 border rounded ${selectedSize === size
                        ? 'bg-black text-white'
                        : 'bg-[#f0f0f0]'
                        }`}
                    >
                      {size}
                    </button>
                  ))}
                </div>
              </div>


              {/* Quantity Selection */}
              <div className="mb-6">
                <div className="text-sm mb-3">الكمية</div>
                <div className="flex items-center border rounded-lg w-32 flex-row-reverse">
                  <button
                    onClick={() => handleQuantityChange('increase')}
                    className="p-3 hover:bg-gray-100 rounded-r-lg"
                  >
                    <Plus className="w-4 h-4" />
                  </button>
                  <div className="flex-1 text-center font-semibold">{quantity}</div>
                  <button
                    onClick={() => handleQuantityChange('decrease')}
                    className="p-3 hover:bg-gray-100 rounded-l-lg"
                    disabled={quantity <= 1}
                  >
                    <Minus className="w-4 h-4" />
                  </button>
                </div>
              </div>

              {/* Add to Cart */}
              <button
                onClick={handleAddToCart}
                style={{ backgroundColor: selectedColorHex }}
                className={`w-full ${textColor} py-2 rounded-lg font-semibold hover:bg-red-700 mb-4 cursor-pointer`}
              >
                شراء الآن - {totalPrice} درهم
                <div className="text-xs">متوفر، جاهز للشحن</div>
              </button>

              {/* Features */}
              <div className="border-t border-b pt-6 pb-3 space-y-4" dir="rtl">
                <details className="cursor-pointer pb-3 border-b border-gray-200">
                  <summary className="flex justify-between items-center font-semibold">
                    <span>الوصف</span>
                    <ChevronDown className="w-5 h-5" />
                  </summary>
                  <div className="mt-2 text-sm text-gray-600 space-y-2">
                    <p>هل تبحثين عن إطلالة تجمع بين الدفء، الجودة، والمظهر العصري؟ طقم "Tracksuit" الجديد باللون الأرجواني العميق هو الاختيار المثالي!</p>
                    <ul className="list-none space-y-1">
                      <li>✅ خامة ممتازة: قطن ناعم يحافظ على الدفء ويتحمل حركة الأطفال المستمرة.</li>
                      <li>✅ تصميم عصري (Over-sized): مريح جداً ومناسب للأولاد والبنات (Unisex).</li>
                      <li>✅ متانة عالية: ألوان ثابتة لا تتغير مع الغسيل المتكرر.</li>
                    </ul>
                    <p>اجعلي طفلك يتألق بإطلالة مميزة هذا الموسم! ❄️</p>
                  </div>
                </details>

                <details className="cursor-pointer py-3 border-b border-gray-200">
                  <summary className="flex justify-between items-center font-semibold">
                    <span>المواد</span>
                    <ChevronDown className="w-5 h-5" />
                  </summary>
                  <p className="mt-2 text-sm text-gray-600">
                    100% قطن، 0% بوليستر. قابل للغسل في الغسالة.
                  </p>
                </details>

                <details className="cursor-pointer pt-3">
                  <summary className="flex justify-between items-center font-semibold">
                    <span>المقاس والقص</span>
                    <ChevronDown className="w-5 h-5" />
                  </summary>
                  <p className="mt-2 text-sm text-gray-600">
                    قص واسع جداً - يوفر قصنا الواسع المزيد من الراحة في منطقة الصدر والكتفين والذراعين، ويضيق حتى الخصر. يتميز بنطلون الرياضة البسيط بقصة أكثر اتساعاً، مع مساحة أكبر قليلاً في منطقة الصدر وطول أكبر من منتجاتنا الأخرى. اختر مقاساً أصغر للحصول على قصة أكثر ملاءمة.
                  </p>
                </details>
              </div>

              {/* Featured Fabric */}
              <div className="mt-6" dir="rtl">
                <h3 className="font-semibold mb-4">النسيج المميز</h3>
                <div className="grid grid-cols-3 gap-4 text-center">
                  <div>
                    <div className="w-16 h-16 mx-auto mb-2 rounded-full border-2 border-gray-900 flex items-center justify-center">
                      <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 24 24"><path fill="#000" d="M6.5 19q-1.871 0-3.185-1.306Q2 16.39 2 14.517q0-1.719 1.175-3.051t2.921-1.431q.337-2.185 2.01-3.61T12 5q2.502 0 4.251 1.749T18 11v1h.616q1.436.046 2.41 1.055T22 15.5q0 1.471-1.014 2.486Q19.97 19 18.5 19zm0-1h12q1.05 0 1.775-.725T21 15.5t-.725-1.775T18.5 13H17v-2q0-2.075-1.463-3.538T12 6T8.463 7.463T7 11h-.5q-1.45 0-2.475 1.025T3 14.5t1.025 2.475T6.5 18m5.5-6" /></svg>
                    </div>
                    <div className="text-xs">نعومة الزبدة</div>
                  </div>
                  <div>
                    <div className="w-16 h-16 mx-auto mb-2 rounded-full border-2 border-gray-900 flex items-center justify-center">
                      <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 21 21"><path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" d="M18.5 7.5V2.522l-5.5.014m5.5-.014l-6 5.907m.5 10.092l5.5.002l-.013-5.5m.013 5.406l-6-5.907M2.5 7.5v-5H8m.5 5.929l-6-5.907M8 18.516l-5.5.007V13.5m6-1l-6 6" stroke-width="1" /></svg>
                    </div>
                    <div className="text-xs">مرونة 4 اتجاهات</div>
                  </div>
                  <div>
                    <div className="w-16 h-16 mx-auto mb-2 rounded-full border-2 border-gray-900 flex items-center justify-center">
                      <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 24 24"><path fill="#000" d="M3.689 21L3 20.312L10.312 13H5v-1h7v7h-1v-5.312zM12 12V5h1v5.312L20.312 3l.688.688L13.688 11H19v1z" /></svg>
                    </div>
                    <div className="text-xs">مقاوم للانكماش</div>
                  </div>
                </div>
              </div>



              {/* Modal */}
              {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                  <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] mt-10 overflow-y-auto">
                    <div className="sticky top-0 bg-white border-b p-6 flex justify-between items-center">
                      <h2 className="text-2xl font-bold">إتمام طلبك</h2>
                      <button onClick={() => setShowModal(false)} className="hover:bg-gray-100 p-2 rounded-full">
                        <X className="w-6 h-6" />
                      </button>
                    </div>

                    <div className="p-6">
                      {/* Product Summary */}
                      <div className="bg-gray-50 p-4 rounded-lg mb-6">
                        <h3 className="font-semibold mb-3">ملخص الطلب</h3>
                        <div className="space-y-2 text-sm">
                          <div className="flex justify-between">
                            <span>المنتج:</span>
                            <span className="font-semibold">الأناقة والراحة التي يستحقها أطفالك في طقم واحد✨</span>
                          </div>
                          <div className="flex justify-between">
                            <span>اللون:</span>
                            <span className="font-semibold">{colors.find(c => c.value === selectedColor)?.name}</span>
                          </div>
                          <div className="flex justify-between">
                            <span>المقاس:</span>
                            <span className="font-semibold">{selectedSize}</span>
                          </div>
                          <div className="flex justify-between">
                            <span>الكمية:</span>
                            <span className="font-semibold">{quantity}</span>
                          </div>
                          <div className="flex justify-between pt-2 border-t">
                            <span className="font-bold">المجموع:</span>
                            <span className="font-bold text-xl text-[#29324c]">{totalPrice} درهم</span>
                          </div>
                        </div>
                      </div>

                      {/* Customer Form */}
                      <form onSubmit={handleSubmitOrder}>
                        <h3 className="font-semibold mb-4">معلومات التوصيل</h3>

                        <div className="space-y-4">
                          <div>
                            <label className="flex items-center justify-between text-sm font-medium mb-2"><span>* الاسم الكامل</span></label>
                            <input
                              type="text"
                              name="fullName"
                              value={formData.fullName}
                              onChange={handleInputChange}

                              className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:border-black"
                              placeholder="أدخل اسمك الكامل"
                            />
                          </div>

                          <div>
                            <label className="flex items-center justify-between text-sm font-medium mb-2"><span>* الهاتف</span></label>
                            <input
                              type="tel"
                              name="phone"
                              value={formData.phone}
                              onChange={handleInputChange}

                              className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:border-black"
                              placeholder="+212 6XX XXX XXX"
                            />
                          </div>

                          <div>
                            <label className="flex items-center justify-between text-sm font-medium mb-2"><span>* العنوان</span></label>
                            <input
                              type="text"
                              name="address"
                              value={formData.address}
                              onChange={handleInputChange}

                              className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:border-black"
                              placeholder="الشارع، الرقم، الشقة..."
                            />
                          </div>

                          <div>
                            <label className="flex items-center justify-between text-sm font-medium mb-2"><span>* المدينة</span></label>
                            <input
                              type="text"
                              name="city"
                              value={formData.city}
                              onChange={handleInputChange}

                              className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:border-black"
                              placeholder="مدينتك"
                            />
                          </div>
                        </div>

                        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-3">
                          <button
                            type="reset"
                            onClick={() => setShowModal(false)}
                            className="flex-1 border border-gray-300 text-gray-700 py-3 rounded-lg font-semibold hover:bg-gray-50 hidden md:block"
                          >
                            إلغاء
                          </button>
                          <button
                            type="submit"
                            className="flex-1 bg-[#29324c] text-white py-3 rounded-lg font-semibold hover:bg-[#374367] disabled:opacity-50 disabled:cursor-not-allowed"
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? 'جاري الإرسال...' : 'تأكيد الطلب'}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {/* Footer */}
        <footer className="bg-[#222] text-gray-300 mt-20">
          <div className="container mx-auto px-4 py-12">
            <div className="grid md:grid-cols-4 gap-8 mb-8">
              {/* Brand */}
              <div>
                <img src={logo} alt="logo" className="w-14 mb-4 h-auto" />
                <p className="text-sm mb-4">
                  ملابس مريحة وأنيقة لأطفالك. جودة ممتازة، أسلوب بسيط.
                </p>
                <div className="flex gap-4">
                  <a href="https://www.facebook.com/share/17ehhEKWB9/?mibextid=wwXIfr" className="hover:text-white transition">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                    </svg>
                  </a>
                  <a href="https://www.instagram.com/oumac_hic?igsh=NWxpc21lZDBtN2Q3&utm_source=qr" className="hover:text-white transition">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                    </svg>
                  </a>
                  <a href="https://www.tiktok.com/@oumac_hic?lang=fr&is_from_webapp=1&sender_device=mobile&sender_web_id=7539752922411976248" className="hover:text-white transition">
                    <svg xmlns="http://www.w3.org/2000/svg" className='w-5 h-5' viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22 6v5q-4 0-6-2v7a7 7 0 1 1-5-6.7m0 6.7a2 2 0 1 0-2 2a2 2 0 0 0 2-2V1h5q2 5 6 5" /></svg>
                  </a>
                </div>
              </div>

              {/* Contact */}
              <div>
                <h3 className="text-white font-semibold mb-4">اتصل بنا</h3>
                <ul className="space-y-2 text-sm">
                  <li>📧 support@oumachic.store</li>
                  <li>📱 +212 691 388 822</li>
                  <li>📍 تيفلت، المغرب</li>
                </ul>
              </div>

              {/* Informations */}
              <div>
                <h3 className="text-white font-semibold mb-4">معلومات</h3>
                <ul className="space-y-2 text-sm">
                  <li><span href="#aa" className="hover:text-white transition">توصيل مجاني</span></li>
                  <li><span href="#aa" className="hover:text-white transition">الدفع عند الاستلام</span></li>
                  <li><span href="#aa" className="hover:text-white transition">24/7</span></li>
                </ul>
              </div>

              {/* Newsletter */}
              <div>
                <h3 className="text-white font-semibold mb-4">النشرة الإخبارية</h3>
                <p className="text-sm mb-4">اشترك للحصول على عروضنا الحصرية</p>
                <div className="flex flex-row-reverse">
                  <button className="bg-white text-gray-900 px-4 py-2 rounded-l-lg font-semibold hover:bg-gray-100 transition">
                    موافق
                  </button>
                  <input
                    type="email"
                    placeholder="بريدك الإلكتروني"
                    className="flex-1 px-4 py-2 rounded-r-lg text-gray-900 focus:outline-none"
                  />
                </div>
              </div>
            </div>

            {/* Bottom Bar */}
            <div className="border-t border-gray-700 pt-6 text-sm text-center">
              <p>© 2024 OumaChic. جميع الحقوق محفوظة.</p>
            </div>
          </div>
        </footer>

        {/* Size Guide Sidebar */}
        {showSizeGuide && (
          <>
            {/* Backdrop */}
            <div
              className="fixed inset-0 bg-black/50 z-50"
              onClick={() => setShowSizeGuide(false)}
            />
            {/* Sidebar */}
            <div className="fixed left-0 top-0 h-full w-full md:w-2/3 lg:w-1/2 bg-white z-50 shadow-2xl overflow-y-auto">
              <div className="p-6">
                {/* Header */}
                <div className="flex items-center justify-between mb-6">
                  <div>
                    <h2 className="text-2xl font-bold mb-1">دليل المقاسات</h2>
                    <p className="text-sm text-gray-600">قص واسع - بنطلون رياضي للأطفال</p>
                  </div>
                  <button
                    onClick={() => setShowSizeGuide(false)}
                    className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                  >
                    <X className="w-6 h-6" />
                  </button>
                </div>

                {/* Tabs */}
                <div className="flex gap-2 mb-6 border-b">
                  <button
                    onClick={() => setActiveTab('body')}
                    className={`px-4 py-2 text-sm font-medium transition-colors ${activeTab === 'body'
                      ? 'bg-black text-white'
                      : 'bg-white text-black hover:bg-gray-100'
                      }`}
                  >
                    مقاسات الجسم
                  </button>
                  <button
                    onClick={() => setActiveTab('image')}
                    className={`px-4 py-2 text-sm font-medium transition-colors ${activeTab === 'image'
                      ? 'bg-black text-white'
                      : 'bg-white text-black hover:bg-gray-100'
                      }`}
                  >
                    صورة
                  </button>
                </div>

                {/* Content */}
                {activeTab === 'body' && (
                  <div>
                    <h3 className="text-sm font-medium mb-2">كيفية القياس</h3>
                    <p className="text-sm text-gray-600 mb-6">
                      تم تصميم المقاسات لتتوافق مع المقاسات الجسدية التالية:
                    </p>

                    {/* Size Table */}
                    <div className="overflow-x-auto">
                      <table className="w-full border-collapse">
                        <thead>
                          <tr className="border-b">
                            <th className="text-right py-3 px-4 font-semibold text-sm">المقاس</th>
                            <th className="text-right py-3 px-4 font-semibold text-sm">العمر</th>
                            <th className="text-right py-3 px-4 font-semibold text-sm">محيط الخصر</th>
                            <th className="text-right py-3 px-4 font-semibold text-sm">الوركين</th>
                            <th className="text-right py-3 px-4 font-semibold text-sm">الخطوة</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="border-b">
                            <td className="py-3 px-4 text-sm">L</td>
                            <td className="py-3 px-4 text-sm">Standard</td>
                            <td className="py-3 px-4 text-sm">
                              {unit === 'CM' ? '65-69 سم' : '25.6-27.2 بوصة'}
                            </td>
                            <td className="py-3 px-4 text-sm">
                              {unit === 'CM' ? '76-81 سم' : '29.9-31.9 بوصة'}
                            </td>
                            <td className="py-3 px-4 text-sm">
                              {unit === 'CM' ? '61.6 سم' : '24.3 بوصة'}
                            </td>
                          </tr>
                          <tr className="border-b">
                            <td className="py-3 px-4 text-sm">XL</td>
                            <td className="py-3 px-4 text-sm">Large</td>
                            <td className="py-3 px-4 text-sm">
                              {unit === 'CM' ? '69-72 سم' : '27.2-28.3 بوصة'}
                            </td>
                            <td className="py-3 px-4 text-sm">
                              {unit === 'CM' ? '81-89 سم' : '31.9-35.0 بوصة'}
                            </td>
                            <td className="py-3 px-4 text-sm">
                              {unit === 'CM' ? '66 سم' : '26.0 بوصة'}
                            </td>
                          </tr>
                          <tr>
                            <td className="py-3 px-4 text-sm">XXL</td>
                            <td className="py-3 px-4 text-sm">X-Large</td>
                            <td className="py-3 px-4 text-sm">
                              {unit === 'CM' ? '73-76 سم' : '28.7-29.9 بوصة'}
                            </td>
                            <td className="py-3 px-4 text-sm">
                              {unit === 'CM' ? '90-98 سم' : '35.4-38.6 بوصة'}
                            </td>
                            <td className="py-3 px-4 text-sm">
                              {unit === 'CM' ? '70 سم' : '27.6 بوصة'}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {activeTab === 'image' && (
                  <div>
                    <p className="text-sm text-gray-600">
                      <img src={taille} alt="" className='w-[400px] h-auto' />
                    </p>
                  </div>
                )}

                {/* Unit Toggle */}
                <div className="flex justify-start mt-8 pt-6 border-t">
                  <div className="flex items-center gap-2">
                    <span className={`text-sm font-medium ${unit === 'CM' ? 'text-black' : 'text-gray-400'}`}>
                      سم
                    </span>
                    <button
                      onClick={() => setUnit(unit === 'CM' ? 'IN' : 'CM')}
                      className={`relative w-12 h-6 rounded-full transition-colors ${unit === 'CM' ? 'bg-black' : 'bg-gray-300'
                        }`}
                    >
                      <span
                        className={`absolute top-1 right-1 w-4 h-4 bg-white rounded-full transition-transform ${unit === 'CM' ? 'translate-x-0' : '-translate-x-6'
                          }`}
                      />
                    </button>
                    <span className={`text-sm font-medium ${unit === 'IN' ? 'text-black' : 'text-gray-400'}`}>
                      بوصة
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {/* Toast Notifications */}
        <Toaster
          position="top-center"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
              fontFamily: 'system-ui, -apple-system, sans-serif',
            },
            success: {
              style: {
                background: '#10B981',
              },
            },
            error: {
              style: {
                background: '#EF4444',
              },
            },
            loading: {
              style: {
                background: '#3B82F6',
              },
            },
          }}
        />
      </div>
    </>
  );
}